import { __require as requireEn } from "../node_modules/.pnpm/dayjs@1.11.13/node_modules/dayjs/locale/en.js";
requireEn();
//# sourceMappingURL=en.js.map
